@if (showCard()) {
    <section class="bg-p-content-bg border border-p-border rounded-lg p-5 flex flex-col gap-3">
        <div class="flex flex-col gap-1">
            <h3 class="text-base font-semibold text-p-text m-0">
                {{ 'bookingV2.orderLink.title' | translate }}
            </h3>
            <p class="text-sm text-p-text-muted m-0">
                {{ 'bookingV2.orderLink.subtitle' | translate }}
            </p>
        </div>

        @if (!orderOptions().length) {
            <p class="text-sm text-p-text-muted m-0">{{ 'bookingV2.orderLink.noOpenOrders' | translate }}</p>
        } @else {
            <p-select
                styleClass="w-full"
                appendTo="body"
                optionLabel="label"
                optionValue="value"
                [showClear]="true"
                [options]="orderOptions()"
                [ngModel]="selectedOrderId()"
                (ngModelChange)="onOrderChange($event)"
                [placeholder]="('bookingV2.orderLink.placeholder' | translate)">
                <ng-template #dropdownicon><span class="material-icons">expand_more</span></ng-template>
                <ng-template #clearicon><span class="material-icons">close</span></ng-template>
            </p-select>
            <p class="text-xs text-p-text-muted m-0">{{ 'bookingV2.orderLink.hint' | translate }}</p>
        }
    </section>
}
